<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.4231 8.66211C16.2343 8.66215 16.0528 8.73963 15.9182 8.87793C15.7835 9.01639 15.7073 9.20506 15.7073 9.40234C15.7074 9.59945 15.7836 9.78744 15.9182 9.92578L17.0129 11.043L17.2297 11.2637H5.00708L4.87329 11.2842C4.74242 11.3173 4.62233 11.3888 4.52759 11.4912C4.40111 11.628 4.3301 11.81 4.33032 12V12.0371C4.33905 12.2207 4.41374 12.3944 4.53931 12.5234C4.66467 12.6521 4.83154 12.7274 5.00708 12.7363H17.2297L17.0129 12.957L15.9172 14.0742C15.8502 14.1425 15.7975 14.2245 15.761 14.3145C15.7245 14.4044 15.7053 14.501 15.7053 14.5986C15.7053 14.6962 15.7245 14.7929 15.761 14.8828C15.7974 14.9726 15.8504 15.0539 15.9172 15.1221L15.9182 15.123C15.9847 15.1919 16.064 15.2461 16.1506 15.2832C16.2371 15.3202 16.3296 15.3398 16.4231 15.3398C16.5167 15.3398 16.6099 15.3203 16.6965 15.2832C16.783 15.2461 16.8616 15.1918 16.928 15.123H16.929L19.4573 12.5244H19.4583C19.5252 12.4561 19.578 12.3741 19.6145 12.2842C19.6509 12.1943 19.6702 12.0976 19.6702 12C19.6701 11.9024 19.651 11.8057 19.6145 11.7158C19.5781 11.6261 19.5251 11.5447 19.4583 11.4766L19.4573 11.4756L16.929 8.87793C16.7943 8.73959 16.612 8.66211 16.4231 8.66211Z"
      fill="#fff"
      stroke="#e1e1e1"
      stroke-width="0.26"
    />
    <path
      d="M18.573 17.5996H5.00073C4.63365 17.5998 4.32983 17.9071 4.32983 18.293V18.3789C4.32983 18.7648 4.63365 19.0721 5.00073 19.0723H18.573C18.9402 19.0722 19.2439 18.7649 19.2439 18.3789V18.293C19.2439 17.907 18.9402 17.5996 18.573 17.5996Z"
      fill="#fff"
      stroke="#e1e1e1"
      stroke-width="0.26"
    />
    <path
      d="M18.573 4.92993H5.00073C4.63365 4.93007 4.32983 5.23742 4.32983 5.62329V5.70923C4.32983 6.0951 4.63365 6.40245 5.00073 6.40259H18.573C18.9402 6.40256 19.2439 6.09517 19.2439 5.70923V5.62329C19.2439 5.23735 18.9402 4.92996 18.573 4.92993Z"
      fill="#fff"
      stroke="#e1e1e1"
      stroke-width="0.26"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
